import { styled } from 'theme'

export const StyledRealEstateCitySelect = styled.div`
  padding-top: 1rem;
`
